import React, { useState, useEffect, useRef } from "react";
import propTypes from "prop-types";
import { Wrapper } from "@googlemaps/react-wrapper";
import { GoogleMapsOverlay } from "@deck.gl/google-maps";
import { HeatmapLayer } from "@deck.gl/aggregation-layers";
import { FlexContainer } from "../Containers";

const Map = ({ chartData }) => {
  const ref = useRef(null);
  const [map, setMap] = useState();

  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {
        center: { lat: 39.8283, lng: -98.5795 },
        zoom: 3,
      }));
    }
  }, [ref, map]);

  useEffect(() => {
    if (!chartData || !map) return;

    const points = Object.entries(chartData)
      .map(([key, value]) => {
        const [lat, lng] = key.split(",");
        if (lat !== "null" && lng !== "null") {
          return { lat: parseFloat(lat), lng: parseFloat(lng), weight: value };
        }
        return null;
      })
      .filter(Boolean);

    const heatmapLayer = new HeatmapLayer({
      id: "heatmap",
      data: points,
      getPosition: (d) => [d.lng, d.lat],
      getWeight: (d) => d.weight,
      radiusPixels: 20,
      aggregation: "SUM",
    });

    const overlay = new GoogleMapsOverlay({ layers: [heatmapLayer] });
    overlay.setMap(map);

    points.forEach((point) => {
      const contentString = `<div id="content">
        <div id="bodyContent">
        <div id="firstHeading" class="firstHeading">Redemptions: ${point.weight}</div>
        </div>
        </div>`;

      const markerInstance = new window.google.maps.Marker({
        position: { lat: point.lat, lng: point.lng },
        map: map,
      });

      const infoWindow = new window.google.maps.InfoWindow({
        content: contentString,
        maxWidth: 200,
      });

      window.google.maps.event.addListener(infoWindow, "domready", () => {
        const closeButton = document.querySelector(".gm-ui-hover-effect");
        if (closeButton) closeButton.style.display = "none";
      });

      markerInstance.setOpacity(0);
      markerInstance.setCursor("pointer");

      window.google.maps.event.addListener(markerInstance, "mouseover", function () {
        infoWindow.open(map, markerInstance);
      });
      window.google.maps.event.addListener(markerInstance, "mouseout", function () {
        infoWindow.close();
      });
    });

    return () => {
      overlay.setMap(null);
    };
  }, [chartData, map]);

  return (
    <FlexContainer
      height="400px"
      width="100%"
      direction="column"
      alignItems="center"
      justifyContent="center"
      margin="10px 0 0 0"
    >
      <div ref={ref} style={{ width: "100%", height: "100%" }} />
    </FlexContainer>
  );
};

const GeoChart = ({ data }) => {
  return (
    <>
      {data && (
        <Wrapper apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
          <Map chartData={data} />
        </Wrapper>
      )}
    </>
  );
};

export default GeoChart;

GeoChart.propTypes = {
  data: propTypes.object,
};
